module.exports = __webpack_public_path__ + "img/calendar.3c2e736f.svg";